import { wrappingModule } from './wrapping'

export default wrappingModule
